<template>
    <div class="table-container">
        <div
            class="item-parent"
            ref="table"
            v-for="(i, index) in items"
            :key="i.index"
            :class="i.parentClass"
            v-bind:style="i.mainStyle"
        >
            <div
                v-if="i.keyTitle"
                class="item-title"
                v-bind:style="i.titleStyle"
                :title="i.keyOption ? i.keyOption.tooltip : ''"
            >
              <span
                  v-if="custom"
              >
                {{i.keyTitle}}
              </span>
              <template
                  v-else
              >
                {{i.keyTitle}}
              </template>
                <button
                    id="item-tooltip"
                    class="item-tooltip"
                    :class="i.class"
                    v-if="i.tooltip && i.tooltip.msg !== ''"
                    v-tooltip="{
                      content: i.tooltip.msg,
                      show: tooltipOpenIndex === index && tooltipOpen,
                      trigger: 'click',
                    }"
                    style="padding: 0"
                    @mouseover="handleMouseOver(index)"
                    @mouseout="handleMouseOut"
                    @click="handleClick"
                >?</button>
            </div>
            <component
                class="item-value"
                :is="i.keyType"
                :item="i"
                style="word-break: break-word; line-height: 16px;"
            />
        </div>
    </div>
</template>
<script>
import Types from '@/components/Table/types'

export default {
  props: ['items', 'custom'],
  components: {
    DefaultInput: Types.DefaultInput,
    RadioBox: Types.RadioBox,
    GenderRadioBox: Types.GenderRadioBox,
    EmailInput: Types.EmailInput,
    SingleDateInput: Types.SingleDateInput,
    DateRangeInput: Types.DateRangeInput,
    DefaultInfoInput: Types.DefaultInfoInput,
    SelectBox: Types.SelectBox,
    SelectOptionBox: Types.SelectOptionBox,
    ButtonSelectBox: Types.ButtonSelectBox,
    SearchSelectBox: Types.SearchSelectBox,
    UnitSelectBox: Types.UnitSelectBox,
    ImageSelector: Types.ImageSelector,
    TextArea: Types.TextArea,
    Default: Types.Default,
    NumberInput: Types.NumberInput,
    PasswordInput: Types.PasswordInput,
    ImagePreview: Types.ImagePreview,
    DeleteBtn: Types.DeleteBtn,
    TaggableMultipleSelect: Types.TaggableMultipleSelect,
  },
  data() {
    return {
      starImages: {
        on: '/images/star_blue.png',
        off: '/images/star_gray.png'
      },
      tooltipOpen: false,
      tooltipOpenIndex: '',
    }
  },
  methods: {
    handleMouseOver(index) {
      this.tooltipOpen = true;
      this.tooltipOpenIndex = index;
    },
    handleMouseOut() {
      this.tooltipOpen = false;
      this.tooltipOpenIndex = '';
    },
    handleClick() {
      this.tooltipOpen = !this.tooltipOpen;
    }
  }
}
</script>
<style lang="scss">
    .item-tooltip {
        border-radius: 50px;
        width: 18px;
        height: 18px;
        font-size: smaller;
        border: none;
        background: #c8c8c8;
        color: var(--white);
        padding-top: 1px;
        font-size: 11px;
        font-weight: 700;
        cursor: pointer;
        &:focus {
            outline: none;
        }
    }
    .tooltip {
        display: block !important;
        z-index: 10000 !important;
        .tooltip-inner {
            background: var(--grey70);
            color: var(--white);
            border-radius: 16px;
            padding: 10px 15px;
        }

        .tooltip-arrow {
            width: 0;
            height: 0;
            border-style: solid;
            position: absolute;
            margin: 5px;
            border-color: var(--grey70);
        }

        &[x-placement^="top"] {
            margin-bottom: 5px;

            .tooltip-arrow {
                border-width: 5px 5px 0 5px;
                border-left-color: transparent !important;
                border-right-color: transparent !important;
                border-bottom-color: transparent !important;
                bottom: -5px;
                left: calc(50% - 5px);
                margin-top: 0;
                margin-bottom: 0;
            }
        }

        &[x-placement^="bottom"] {
            margin-top: 5px;

            .tooltip-arrow {
                border-width: 0 5px 5px 5px;
                border-left-color: transparent !important;
                border-right-color: transparent !important;
                border-top-color: transparent !important;
                top: -5px;
                left: calc(50% - 5px);
                margin-top: 0;
                margin-bottom: 0;
            }
        }

        &[x-placement^="right"] {
            margin-left: 5px;

            .tooltip-arrow {
                border-width: 5px 5px 5px 0;
                border-left-color: transparent !important;
                border-top-color: transparent !important;
                border-bottom-color: transparent !important;
                left: -5px;
                top: calc(50% - 5px);
                margin-left: 0;
                margin-right: 0;
            }
        }

        &[x-placement^="left"] {
            margin-right: 5px;

            .tooltip-arrow {
                border-width: 5px 0 5px 5px;
                border-top-color: transparent !important;
                border-right-color: transparent !important;
                border-bottom-color: transparent !important;
                right: -5px;
                top: calc(50% - 5px);
                margin-left: 0;
                margin-right: 0;
            }
        }

        &[aria-hidden='true'] {
            visibility: hidden;
            opacity: 0;
            transition: opacity .15s, visibility .15s;
        }

        &[aria-hidden='false'] {
            visibility: visible;
            opacity: 1;
            transition: opacity .15s;
        }
    }
    .table-container {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 50px;
        width: 100%;
        text-align: left;

        .item-parent {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin: 0.5rem;

            &.columns_2 {
                grid-column: 1/3;
            }
            &.columns_4 {
                grid-column: 1/5 !important;
            }
            &.row_2 {
                grid-row: 1/3;
            }

            .item-title {
                flex: 1 1 1rem;
            }

            .item-value {
                flex: 3 3 1rem;
            }
        }
    }
</style>